import ringsignals from "./ringsignals";
import language from "../language/language.js";
import packagejson from "../../../../package.json";
import AdapterJS from "adapterjs";
import detect from "detect-browser";
import configoverride from "../../current/configoverride.js";
import { WebChatLayout } from "../../../types";

var config = {};

/****************************************************************************************************/
// SERVER
/****************************************************************************************************/

//eslint-disable-next-line
var dev =
  [
    //
    // Enter the hostname or IP of your dev environment here.
    //
    "localhost",
    "10.0.75.84",
    "10.0.75.165",
    "10.0.75.92",
    "192.168.2.32",
    "192.168.2.201",
  ].indexOf(window.location.hostname) >= 0;

//eslint-disable-next-line
var wsProtocol = location.protocol === "https:" ? "wss:" : "ws:";

//
// It is possible to change which MMX server to use in development mode
// by setting the environment variable REACT_APP_MMX_SERVER.
//
// On macos and linux it can be set in the shell with:
// > export REACT_APP_MMX_SERVER="10.0.75.30.xip.io"
//
// On windows it can be set with:
// ????
//
if (dev) {
  var server = "dev.nwise.se";
  //var server = "10.0.75.30.xip.io";
  //var server = window.location.hostname; //Should be the used when in production
  if (
    process.env.REACT_APP_MMX_SERVER &&
    process.env.REACT_APP_MMX_SERVER.length !== 0
  ) {
    server = process.env.REACT_APP_MMX_SERVER;
  }
  config["server"] = "https://" + server;
  config["serverws"] = "wss://" + server + "/userApi/server_interface";
} else {
  config["server"] =
    window.location.protocol +
    "//" +
    window.location.hostname +
    ":" +
    window.location.port;
  config["serverws"] =
    wsProtocol + "//" + window.location.hostname + "/userApi/server_interface";
}

config["dev"] = dev ? true : false;
config.version = packagejson.version;

/****************************************************************************************************/
// APPLICATION MODE
/****************************************************************************************************/
config.mode = {
  anonymous_enabled: false, //Anonymous login enabled
  anonymous_autologin: false, //Login as anonymous automatically
  authenticated_enabled: true, //Authenticated login enabled
  services_enabled: true, //Services tab visible
  contacts_enabled: true, //Contacts tab visible
  call_enabled: true, //Call tab visible
  history_enabled: true, //History tab visible
  messages_enabled: true, //Message tab visible
  settings_enabled: true, //Settings tab visible
  display_settings_in_menu: true, //Display settings instead of account in menu
  logout_enabled: true, //Show logout button in topbar instead of in settings menu
  name_enabled: false, //Shows name in top right corner
  online_enabled: true, //Online symbol visible in
  home: "services", //Home page. Possible values: services, contacts, call, history, messages
  kiosk: false, //Kiosk mode
  kiosk_main_layout: false, //Use the "normal" layout in kiosk mode
  restrict: false, //Restrict Kiosk to only call registred numbers
  inIframe: false, //Can the page be displayed in an iFrame
  forceIframe: false, //Must the page be displayed in an iFrame
  registration_enabled: true, //Registration enabled
  resetpassword_enabled: true, //Reset password enabled
  changeuser_enabled: true, //Change user account enabled
  setting_text_enabled: true, //Enable change text on settings
  setting_text_visible_by_default: true, //Whether the text should be visible by default or not
  setting_ringtone_enabled: true, //Enable change ringtone in settings
  setting_media_enabled: true, //Enable change used media on settings
  setting_message_enabled: true, //Enable change message on settings
  text_in_footer: true, // Display Call with audio ON/OFF in footer
  use_double_audio_icons_in_footer: false, //Display both mic and speaker in footer
  buttons_in_footer: true, //Show media buttons in footer
  link_to_settings_in_footer: false, // Display link to media settings in footer
  debug_enabled: true, //Enable debug
  debug_enabled_in_menu: false, //Enable debug in menu
  register_with_userpart_from_sip: true, // Use the userpart from the SIP-address instead of username in register
  dialpad: true, //Enable or disable the in call dialpad
  audio: true, //Enable/disable audio
  video: true, //Enable/disable video
  safetext: true, //Enable/disable text
  opensips: false,
};

if (configoverride.mode) {
  config = {
    ...config,
    mode: {
      ...configoverride.mode,
    },
  };
}

/*
if (config.dev === true) {
    config.mode.debug_enabled = true;
    config.mode.debug_enabled_in_menu = true;
}*/

/****************************************************************************************************/
// LANGUAGE
/****************************************************************************************************/
var lang = language(configoverride.texts);
config.texts = lang.texts;
config.text = lang.text;
if (configoverride.texts) {
  config = {
    ...config,
    texts: {
      ...config.texts,
      ...configoverride.texts,
    },
  };
}

/****************************************************************************************************/
// ANYNOMOUS
/****************************************************************************************************/

//OBS! This user must be set as "multiuser" in admin web
config.anonymous = {
  icon: "",
  user: "anonymous",
  password: "xxxxx",
};
if (configoverride.anonymous) {
  config = {
    ...config,
    anonymous: {
      ...config.anonymous,
      ...configoverride.anonymous,
    },
  };
}

/****************************************************************************************************/
// PASSWORD
/****************************************************************************************************/
config.password = {
  passwordregex: "^.{6,20}$",
};
if (configoverride.password) {
  config = {
    ...config,
    password: {
      ...config.password,
      ...configoverride.password,
    },
  };
}

/****************************************************************************************************/
// REGISTRATION
/****************************************************************************************************/
config.registration = {
  orgid: "1",
  recaptcha: false,
  autogeneratepassword: false,
  // To enable registration into a choice of organisations add a like like the following to the config override
  // organisations: [{orgid: 68, name: 'organisations.name'}],
  // Remember to also add the name of the organisation to the translation strings in the same file
  license: true,
  sendRegistrationMail: true,
};
if (configoverride.registration) {
  config = {
    ...config,
    registration: {
      ...config.registration,
      ...configoverride.registration,
    },
  };
}

/****************************************************************************************************/
// RESET PASSWORD
/****************************************************************************************************/
config.resetpassword = {
  orgid: "1",
  recaptcha: false,
};
if (configoverride.resetpassword) {
  config = {
    ...config,
    resetpassword: {
      ...config.resetpassword,
      ...configoverride.resetpassword,
    },
  };
}

/****************************************************************************************************/
// RECAPTCHA
/****************************************************************************************************/
config.recaptchakey = "6LfTEDEUAAAAANAa1e7bMZPeWKozvrEMtgUlBGrA";
if (config.dev) {
  config.recaptchakey = "6LeLny8UAAAAAHPnnLuFMzpwGFi2sjnOHaQwNIMv";
}
if (configoverride.recaptchakey) {
  config.recaptchakey = configoverride.recaptchakey;
}

/****************************************************************************************************/
// DEFAULT CHAT LAYOUT
/****************************************************************************************************/

config.webchatlayout = WebChatLayout.OVER_UNDER;

if (configoverride.webchatlayout) {
  config.webchatlayout = configoverride.webchatlayout;
}

/****************************************************************************************************/
// FONT AND FONTSIZE
/****************************************************************************************************/

var fonts = {};
fonts.fontcolors_default_senttextforeground = "black";
fonts.fontcolors_default_senttextbackground = "white";
fonts.fontcolors_default_rectextforeground = "black";
fonts.fontcolors_default_rectextbackground = "white";
fonts.fontcolors = [
  { text: config.text("settings.white"), value: "white" },
  { text: config.text("settings.lightgrey"), value: "lightgrey" },
  { text: config.text("settings.darkgrey"), value: "darkgrey" },
  { text: config.text("settings.black"), value: "black" },
  { text: config.text("settings.blue"), value: "blue" },
  { text: config.text("settings.green"), value: "green" },
  { text: config.text("settings.yellow"), value: "yellow" },
  { text: config.text("settings.orange"), value: "orange" },
  { text: config.text("settings.red"), value: "red" },
  { text: config.text("settings.pink"), value: "pink" },
  { text: config.text("settings.purple"), value: "purple" },
];

fonts.fonts_default = "times";
fonts.fonts = [
  { text: config.text("settings.times"), value: "times" },
  { text: config.text("settings.arial"), value: "arial" },
  { text: config.text("settings.trebuchet"), value: "trebuchet" },
  { text: config.text("settings.lucida"), value: "lucida" },
  { text: config.text("settings.verdana"), value: "verdana" },
  { text: config.text("settings.comicsans"), value: "comicsans" },
  { text: config.text("settings.couriernew"), value: "couriernew" },
];

fonts.fontsizes_default = "18";
fonts.fontsizes = [
  { text: "8", value: "8" },
  { text: "10", value: "10" },
  { text: "12", value: "12" },
  { text: "14", value: "14" },
  { text: "16", value: "16" },
  { text: "18", value: "18" },
  { text: "20", value: "20" },
  { text: "22", value: "22" },
  { text: "24", value: "24" },
  { text: "36", value: "36" },
  { text: "48", value: "48" },
  { text: "96", value: "96" },
];
config.fonts = fonts;

if (configoverride.fonts) {
  config = {
    ...config,
    fonts: {
      ...config.fonts,
      ...configoverride.fonts,
    },
  };
}

/****************************************************************************************************/
// AUDIO
/****************************************************************************************************/

config.ringsignals_default = "BELL";
config.ringsignals = ringsignals(config.text);
if (configoverride.ringsignals_default) {
  config.ringsignals_default = configoverride.ringsignals_default;
}
if (configoverride.ringsignals) {
  config.ringsignals = configoverride.ringsignals;
}

/****************************************************************************************************/
// Temasys plugin
/****************************************************************************************************/
config.browser = detect.detect();
if (
  config &&
  config.browser &&
  config.browser.os &&
  (config.browser.os === "iOS" || config.browser.os.indexOf("Android") !== -1)
) {
  //Hide plugin install on android and ios
  AdapterJS.options.hidePluginInstallPrompt = true;
}

/****************************************************************************************************/
// Browsergroup for Freeswitch selection
/****************************************************************************************************/
config.browserH264 = ["ios", "safari", "firefox", "chrome"];
if (configoverride.browserH264) {
  config.browserH264 = configoverride.browserH264;
}

if (config.browserH264.indexOf(config.browser.name.toLowerCase()) >= 0) {
  config.browserGroup = 1;
} else {
  config.browserGroup = 0;
}

export default config;






// WEBPACK FOOTER //
// ./src/branding/default/js/config.js